import {
  POIIcon_default
} from "./chunk-QFFT3R46.mjs";
export {
  POIIcon_default as default
};
